import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const reviews = [
  {
    name: "Marco T.",
    location: "Varese",
    text: "Pensavo di dover pagare una fortuna per svuotare l'appartamento di mio nonno. Invece, grazie alla valutazione di alcuni mobili anni '60, lo sgombero è stato praticamente gratuito. Professionali e veloci.",
    saving: "Risparmio ottenuto: €800",
    delay: 0
  },
  {
    name: "Giulia R.",
    location: "Monza",
    text: "Avevo una cantina piena da anni. Mi hanno fatto il preventivo su WhatsApp in 10 minuti. Hanno recuperato dei vecchi lampadari scalandoli dal prezzo finale. Consigliatissimi!",
    saving: "Risparmio ottenuto: €350",
    delay: 0.2
  },
  {
    name: "Antonio M.",
    location: "Como",
    text: "Servizio impeccabile. Mi hanno risposto subito, sono venuti dopo due giorni e hanno lasciato tutto pulito. Il fatto che valutino l'usato è un vantaggio enorme rispetto alla concorrenza.",
    saving: "Risparmio ottenuto: €450",
    delay: 0.4
  }
];

export default function Reviews() {
  return (
    <section className="py-24 bg-maaich-black border-t border-white/5 overflow-hidden">
      <div className="container mx-auto px-5">
        <div className="flex flex-col md:flex-row justify-between items-center mb-20 gap-8">
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-6xl font-display uppercase italic leading-none mb-4">
              Cosa dicono <br />
              <span className="text-maaich-lime text-5xl md:text-8xl">I Nostri Clienti</span>
            </h2>
          </div>
          <div className="bg-white/5 border border-white/10 p-6 rounded-xl flex items-center gap-4">
            <div className="flex flex-col">
              <div className="flex text-maaich-lime text-xl">
                {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current" />)}
              </div>
              <span className="text-white/60 text-sm uppercase tracking-widest mt-1">Recensioni Verificate</span>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {reviews.map((rev, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: rev.delay, duration: 0.6 }}
              className="relative group"
            >
              {/* Editorial Design Elements */}
              <div className="absolute -top-6 -left-4 text-maaich-lime/10 text-9xl font-display pointer-events-none">“</div>
              
              <div className="relative z-10 bg-white/5 border-l-2 border-maaich-lime p-8 pt-10 hover:bg-white/[0.08] transition-all duration-500">
                <div className="flex items-center gap-1 text-maaich-lime mb-6 text-sm">
                  {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current" />)}
                </div>
                
                <p className="text-xl md:text-2xl font-body font-light text-white leading-relaxed italic mb-8">
                  "{rev.text}"
                </p>
                
                <div className="flex items-center justify-between border-t border-white/10 pt-6">
                  <div>
                    <h4 className="font-display text-white text-lg uppercase italic">{rev.name}</h4>
                    <p className="text-white/40 text-xs uppercase tracking-widest">{rev.location}</p>
                  </div>
                  <div className="bg-maaich-lime/10 px-3 py-1 rounded text-maaich-lime text-[10px] font-display uppercase italic border border-maaich-lime/20">
                    {rev.saving}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="mt-20 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <p className="text-white/30 font-body italic">
            La trasparenza è il nostro valore principale. Ogni valutazione è documentata nel preventivo.
          </p>
        </motion.div>
      </div>
    </section>
  );
}